getQueryRef